import Api from "@/services/Api";

export default {
 
  uploadDPD(formData) {
    return Api().post("carrier/invoice/upload/dpd", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  
  uploadDHL(formData) {
    return Api().post("carrier/invoice/upload/dhl", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

};